export const BOARD_CONFIG_RULES = {
  maxFileSize: parseInt(
    process.env.REACT_APP_BOARDS_MAX_FILE_SIZE ||
    process.env.REACT_APP_DEFAULT_MAX_FILE_SIZE ||
    "100"
  ),
};
